import React from 'react';
import Statistics2511 from './Statistics2511.jsx';

function StatisticsCurrent() {
  return <Statistics2511 />;
}

export default StatisticsCurrent;
